import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import bannerImg from '../assets/images/banner.png';
import mainImg from '../assets/images/static guarding.png';

// --- CORE SERVICES IMAGE IMPORTS ---
import corporateImg from '../assets/images/corporate-security.png';
import conciergeImg from '../assets/images/concierge.jpg';
import mobilePatrolImg from '../assets/images/mobile-patrols.png';
import keyHoldingImg from '../assets/images/key-holding.png';

// --- ACCREDITATION LOGO IMPORTS ---
import acclaimLogo from '../assets/accreditationlogos/Acclaim-accreditation-logo.png';
import acsLogo from '../assets/accreditationlogos/ACS-logo.png';
import armedForcesLogo from '../assets/accreditationlogos/Armed-Forces-Covenant-logo.png';
import bicscLogo from '../assets/accreditationlogos/BICSc-logo.png';
import constructionLineLogo from '../assets/accreditationlogos/Construction-line-gold-member-logo.png';
import disabilityConfidentLogo from '../assets/accreditationlogos/Disability-confident-logo.png';
import investorsInPeopleLogo from '../assets/accreditationlogos/Investors-in-people-logo.png';
import iso9001Logo from '../assets/accreditationlogos/ISO-9001-logo.png';
import iso14001Logo from '../assets/accreditationlogos/ISO-14001-logo.png';
import iso45001Logo from '../assets/accreditationlogos/ISO-45001-logo.png';
import nasduLogo from '../assets/accreditationlogos/NASDU-logo.png';
import risqsLogo from '../assets/accreditationlogos/RISQS-logo.png';
import safeContractorLogo from '../assets/accreditationlogos/Safe-contractor-logo.png';
// pacesetterLogo removed

const Services = () => {
  // Pacesetter removed from array
  const accreditationLogos = [
    { src: acclaimLogo, alt: "Acclaim Accreditation" },
    { src: acsLogo, alt: "ACS" },
    { src: armedForcesLogo, alt: "Armed Forces Covenant" },
    { src: bicscLogo, alt: "BICSc" },
    { src: constructionLineLogo, alt: "Construction Line Gold" },
    { src: disabilityConfidentLogo, alt: "Disability Confident" },
    { src: investorsInPeopleLogo, alt: "Investors in People" },
    { src: iso9001Logo, alt: "ISO 9001" },
    { src: iso14001Logo, alt: "ISO 14001" },
    { src: iso45001Logo, alt: "ISO 45001" },
    { src: nasduLogo, alt: "NASDU" },
    { src: risqsLogo, alt: "RISQS" },
    { src: safeContractorLogo, alt: "Safe Contractor" }
  ];

  // Logic for the interactive logo slider
  const [startIndex, setStartIndex] = useState(0);
  const logosToShow = 5; // How many logos fit on the screen at once

  const handleNextLogos = () => {
    setStartIndex((prevIndex) => 
      (prevIndex + logosToShow) >= accreditationLogos.length ? 0 : prevIndex + logosToShow
    );
  };

  const handlePrevLogos = () => {
    setStartIndex((prevIndex) => 
      (prevIndex - logosToShow) < 0 ? Math.max(0, accreditationLogos.length - logosToShow) : prevIndex - logosToShow
    );
  };

  // Slice the array to only show the current 5
  const visibleLogos = accreditationLogos.slice(startIndex, startIndex + logosToShow);

  return (
    <div className="services-page">
      
      {/* INJECTED MOBILE FIXES & PAGE STYLES */}
      <style>
        {`
          /* --- REMOVE GLOBAL HERO ARROW JUST FOR SERVICES PAGE --- */
          .services-hero::after {
            display: none !important;
          }

          /* --- DISABLE HOVER ON STATS CARDS --- */
          .stat-card-no-hover:hover {
            transform: none !important;
            border-bottom-color: var(--color-secondary-light) !important;
            box-shadow: 0 10px 30px rgba(0,0,0,0.05) !important;
          }
          .stat-card-no-hover:hover .stat-label {
            color: var(--color-secondary-grey) !important;
          }
          .stat-card-no-hover:hover::before {
            background-color: var(--color-secondary-light) !important;
            box-shadow: none !important;
          }

          /* --- DISABLE HOVER ON VALUE NAVY CARDS --- */
          .value-navy-card {
            transition: none !important;
          }
          .value-navy-card:hover {
            transform: none !important;
            box-shadow: 0 10px 30px rgba(0,0,0,0.08) !important;
          }

          /* --- METHODOLOGY GRID --- */
          .methodology-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 2rem;
          }

          /* Default desktop nowrap for hero text */
          .hero-nowrap { white-space: nowrap; }

          /* --- PREMIUM MOBILE RESPONSIVE FIXES --- */
          @media (max-width: 992px) {
            .methodology-grid { grid-template-columns: 1fr; }
            .mobile-grid-override { grid-template-columns: repeat(2, 1fr) !important; }
          }

          @media (max-width: 768px) {
            /* Hero adjustments to prevent overlap with header */
            .hero-nowrap { white-space: normal; } 
            .services-hero { padding: 13rem 1.5rem 5rem 1.5rem !important; }
            .services-hero h1 { font-size: 2.5rem !important; line-height: 1.2 !important; }
            .services-hero p.subtitle { font-size: 1.1rem !important; }

            /* Enforce container boundaries globally */
            .container { padding-left: 1.5rem !important; padding-right: 1.5rem !important; }

            /* Section Padding Fixes */
            .about-overview { padding-top: 4rem !important; padding-bottom: 4rem !important; }
            .service-process-section { padding-top: 4rem !important; padding-bottom: 4rem !important; }
            .core-services-section { padding-top: 3rem !important; padding-bottom: 4rem !important; }
            
            .services-header-split { gap: 2rem !important; }
            
            /* CTA Banner Fix */
            .sleek-cta-banner { flex-direction: column; text-align: center; padding: 3rem 1.5rem !important; }
            .sleek-cta-text { min-width: 100% !important; text-align: center !important; }

            .accreditation-carousel-section { padding: 2rem 0 !important; }
          }
        `}
      </style>

      {/* 1. HERO SECTION */}
      <section className="services-hero">
        <div className="container text-center">
          <h1><span className="hero-nowrap">Our Protective Services</span></h1>
          <p className="subtitle">
            Intelligence-led security solutions tailored to mitigate risk, protect assets and ensure operational continuity.
          </p>
        </div>
      </section>

      {/* 2. OVERVIEW / INTRO (Split Layout) */}
      {/* Explicit paddingTop and paddingBottom to preserve horizontal container limits */}
      <section className="about-overview container" style={{ paddingTop: '8rem', paddingBottom: '4rem' }}>
        <div className="services-header-split">
          <div className="header-left-col">
            <h2>Security Built Around Your Operation</h2>
            <p style={{ color: 'var(--color-primary-navy)', fontWeight: '600', fontSize: 'var(--fs-h4)', lineHeight: 'var(--lh-body)' }}>
              Effective security starts with understanding how an organisation works. That's why we tailor our services to the unique requirements of each environment, providing security solutions that support both safety and operational performance.
            </p>
            <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
              Our teams deliver professional security, concierge, keyholding and alarm response services across a wide range of sectors. Acting as an extension of your team, we create secure, welcoming and professionally managed environments for employees, visitors and customers alike.
            </p>
          </div>
          
          <div className="header-right-col" style={{ display: 'flex', alignItems: 'center' }}>
            <div 
              className="card-image-box" 
              style={{ 
                backgroundImage: `url(${mainImg})`, 
                backgroundSize: 'cover', 
                backgroundPosition: 'center', 
                width: '100%',
                minHeight: '400px', 
                borderRadius: '12px', 
                marginBottom: '1.5rem', 
                position: 'relative',
                boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
              }}
            >
            </div>
          </div>
        </div>
      </section>

      {/* 3. METHODOLOGY / PROCESS SECTION (UPDATED LAYOUT) */}
      <section className="service-process-section" style={{ backgroundColor: 'var(--color-white)', paddingTop: '6rem', paddingBottom: '8rem' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2 style={{ color: 'var(--color-primary-navy)' }}>Our Operational Methodology</h2>
            <p style={{ color: 'var(--color-secondary-grey)', maxWidth: '700px', margin: '0 auto', fontSize: 'var(--fs-body)' }}>
              We apply a rigorous, intelligence-led approach to every customer, ensuring that our security solutions are proactive, legally compliant and seamlessly integrated.
            </p>
          </div>
          
          <div className="methodology-grid">
            
            <div className="value-navy-card">
              <h3 style={{ color: 'var(--color-white)', fontSize: 'var(--fs-h3)', marginBottom: '1rem' }}>Understand Your Environment</h3>
              <p style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'var(--color-secondary-light)', lineHeight: 'var(--lh-body)' }}>We take the time to understand how your organisation operates, allowing us to deliver security services tailored to your people, premises and operational requirements.</p>
            </div>
            
            <div className="value-navy-card">
              <h3 style={{ color: 'var(--color-white)', fontSize: 'var(--fs-h3)', marginBottom: '1rem' }}>Become Part of Your Team</h3>
              <p style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'var(--color-secondary-light)', lineHeight: 'var(--lh-body)' }}>Our officers integrate seamlessly into your operation, providing a professional presence that supports security, customer experience and day-to-day activities.</p>
            </div>
            
            <div className="value-navy-card">
              <h3 style={{ color: 'var(--color-white)', fontSize: 'var(--fs-h3)', marginBottom: '1rem' }}>Continually Improve</h3>
              <p style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'var(--color-secondary-light)', lineHeight: 'var(--lh-body)' }}>Through partnership, communication and regular performance reviews, we ensure our services remain effective, responsive and aligned to your needs.</p>
            </div>

          </div>
        </div>
      </section>

      {/* 4. CORE SERVICES DEEP DIVE */}
      <section className="core-services-section" style={{ paddingTop: '6rem' }}>
        <div className="container">
          
          {/* Service 1: Corporate Security */}
          <div className="service-detail-card">
            <div className="service-content">
              <h2>Corporate Security</h2>
              <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
                Our corporate security teams protect workplaces, offices and commercial environments through professional, intelligence-led security. By maintaining strong on-site presence and proactive risk awareness, we help organisations safeguard their people, property and daily operations.
              </p>
              <ul className="service-features" style={{ fontSize: 'var(--fs-body)' }}>
                <li>Professional SIA-licensed corporate guards</li>
                <li>Front-of-house and reception security integration</li>
                <li>Proactive threat identification and risk mitigation</li>
                <li>Comprehensive site patrols and access control</li>
              </ul>
              <Link to="/services/corporate-security" className="btn btn-primary btn-pill mt-4">Explore Corporate Security</Link>
            </div>
            <div className="service-image" style={{ backgroundImage: `url(${corporateImg})`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative' }}>
            </div>
          </div>

          {/* Service 2: Concierge (Reverse Layout) */}
          <div className="service-detail-card reverse-layout">
            <div className="service-content">
              <h2>Concierge Services</h2>
              <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
                Our concierge teams provide a professional front-of-house presence across residential, commercial and mixed-use environments. Acting as the first point of contact for residents, visitors, customers and staff, they support the smooth day-to-day operation of buildings through visitor management, access control and operational oversight. 
              </p>
              <ul className="service-features" style={{ fontSize: 'var(--fs-body)' }}>
                <li>Front-of-house and reception services</li>
                <li>Visitor management and access control</li>
                <li>Building management support</li>
                <li>Health & safety awareness</li>
              </ul>
              <Link to="/services/concierge" className="btn btn-primary btn-pill mt-4">Explore Concierge Services</Link>
            </div>
            <div className="service-image" style={{ backgroundImage: `url(${conciergeImg})`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative' }}>
            </div>
          </div>

          {/* Service 3: Key Holding and Alarm Response */}
          <div className="service-detail-card">
            <div className="service-content">
              <h2>Key Holding & Alarm Response</h2>
              <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
                Our key holding and alarm response service ensures incidents are managed quickly and professionally. Our trained security officers attend sites, assess situations safely and take appropriate action, reducing disruption and protecting your premises.
              </p>
              <ul className="service-features" style={{ fontSize: 'var(--fs-body)' }}>
                <li>Secure, off-site key retention in fully compliant facilities</li>
                <li>Rapid deployment to alarm activations 24/7</li>
                <li>Comprehensive site checks and securing of premises</li>
                <li>Detailed incident reporting and liaison with emergency services</li>
              </ul>
              <Link to="/services/key-holding" className="btn btn-primary btn-pill mt-4">Explore Key Holding</Link>
            </div>
            <div className="service-image" style={{ backgroundImage: `url(${keyHoldingImg})`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative' }}>
            </div>
          </div>

          {/* Service 4: Mobile Patrols (Reverse Layout) */}
          <div className="service-detail-card reverse-layout">
            <div className="service-content">
              <h2>Mobile Patrols</h2>
              <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
                Our mobile patrol services provide flexible security coverage across multiple sites. Through scheduled and responsive patrols, our teams deter unwanted activity, identify risks early and ensure premises remain secure outside normal operating hours.
              </p>
              <ul className="service-features" style={{ fontSize: 'var(--fs-body)' }}>
                <li>Highly visible, branded patrol vehicles</li>
                <li>Randomised and scheduled site inspections</li>
                <li>Perimeter checks and out-of-hours locking/unlocking</li>
                <li>Real-time reporting and fully tracked patrol routes</li>
              </ul>
              <Link to="/services/mobile-patrols" className="btn btn-primary btn-pill mt-4">Explore Mobile Patrols</Link>
            </div>
            <div className="service-image" style={{ backgroundImage: `url(${mobilePatrolImg})`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative' }}>
            </div>
          </div>

        </div>
      </section>

      {/* 5. COMMAND-CENTER STATS SECTION */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-header-text text-center">
            <h2>Security Solutions Built Around People</h2>
            <p className="stats-description" style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
              Providing trusted security services that protect what matters most whilst supporting the day-to-day needs of your organisation.
            </p>
          </div>

          <div className="stats-command-grid">
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">ACS</span>
              <span className="stat-number">Approved</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">24/7</span>
              <span className="stat-number">Helpdesk</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">Strategic</span>
              <span className="stat-number">Consultants</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">24/7</span>
              <span className="stat-number">SOC</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">National</span>
              <span className="stat-number">Coverage</span>
            </div>
          </div>
        </div>
      </section>

      {/* 6. SLEEK FLOATING CTA BANNER */}
      <section style={{ backgroundColor: 'var(--color-white)', paddingTop: '4rem', paddingBottom: '6rem' }}>
        <div className="container">
          <div 
            className="sleek-cta-banner"
            style={{ 
              backgroundImage: `linear-gradient(to right, rgba(23, 44, 79, 0.95), rgba(23, 44, 79, 0.8)), url(${bannerImg})`,
              borderRadius: '16px',
              padding: '3rem 4rem',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
              gap: '2rem',
              flexWrap: 'wrap',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            <div style={{ position: 'absolute', top: '-20px', right: '2%', fontSize: '12rem', color: 'var(--color-white)', opacity: '0.03', pointerEvents: 'none', fontWeight: '900', letterSpacing: '-15px' }}>»»</div>

            <div className="sleek-cta-text" style={{ textAlign: 'left', flex: '1', position: 'relative', zIndex: 2, minWidth: '300px' }}>
              <h2 style={{ color: 'var(--color-white)', marginBottom: '0.5rem', fontSize: '2.1rem', letterSpacing: '-0.5px' }}>Professional Security Management</h2>
              <p style={{ color: 'var(--color-secondary-light)', fontSize: 'var(--fs-body)', margin: 0, maxWidth: '600px', lineHeight: '1.6' }}>
                Discover how our intelligence-led approach can protect your operations.
              </p>
            </div>
            
            <div style={{ position: 'relative', zIndex: 2, flexShrink: 0 }}>
              <Link to="/contact" className="btn btn-pill" style={{ 
                backgroundColor: 'var(--color-white)', 
                color: 'var(--color-primary-navy)', 
                fontWeight: '700', 
                padding: '1rem 2.5rem', 
                fontSize: '0.95rem',
                boxShadow: '0 8px 20px rgba(0,0,0,0.1)'
              }}>
                Contact us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 7. ACCREDITATION CAROUSEL STRIP (Navy Block Removed) */}
      <section className="accreditation-carousel-section" style={{ backgroundColor: 'var(--color-white)', padding: '4rem 0', borderTop: '1px solid rgba(0,0,0,0.05)' }}>
        <div className="container">
          
          <div className="accreditation-interactive-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '2rem' }}>
            
            {/* Left Control Button */}
            <button 
              className="control-btn prev-btn" 
              onClick={handlePrevLogos} 
              aria-label="Previous Logos"
              style={{ backgroundColor: 'var(--color-light)', border: 'none', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--color-primary-navy)', fontSize: '1.5rem', fontWeight: 'bold' }}
            >
              ‹
            </button>

            {/* Logo Display Grid (Shows 5 max) */}
            <div className="accreditation-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '2rem', width: '100%', alignItems: 'center', justifyItems: 'center' }}>
              {visibleLogos.map((logo, index) => (
                <div className="accreditation-slide-static" key={index}>
                  <img 
                    src={logo.src} 
                    alt={logo.alt} 
                    style={{ maxHeight: '70px', objectFit: 'contain' }}
                  />
                </div>
              ))}
            </div>

            {/* Right Control Button */}
            <button 
              className="control-btn next-btn" 
              onClick={handleNextLogos} 
              aria-label="Next Logos"
              style={{ backgroundColor: 'var(--color-light)', border: 'none', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--color-primary-navy)', fontSize: '1.5rem', fontWeight: 'bold' }}
            >
              ›
            </button>

          </div>

        </div>
      </section>

    </div>
  );
};

export default Services;